module.exports = __webpack_public_path__ + "img/ic_camera_scan.f8b7eb1a.gif";